<template>
  <div class="uploadGoogleLogo">
    <div class="flex mr-2">
      <div
        v-for="(img, index) in value"
        class="flex mr-4"
        :key="img.resourceName || img.url || index"
      >
        <div class="relative w-32 h-32">
          <RetryImage
            image-class="w-32 h-32"
            :src="img.url"
            fit="contain"
            :max-retry="3"
            :retry-delay="1500"
          />
          <i
            class="el-icon-circle-close hover:text-primary text-[18px] absolute -top-1 -right-1 cursor-pointer"
            @click="deleItem(index)"
            v-if="!disabled"
          ></i>
        </div>
      </div>

      <div
        v-if="value.length < limit && !disabled"
        class="mr-2 mb-4 w-32 h-32"
      >
        <!-- <el-image
          class="w-24 h-24"
          :src="addImgIcon"
        ></el-image> -->
        <div
          class="leading-4 text-xs border-dashed border-2 w-full h-full flex flex-col justify-center items-center rounded-md"
        >
          <div class="mb-2">
            <el-button
              size="mini"
              @click.stop="openLibrary"
              >素材库选择</el-button
            >
          </div>
          <el-button
            type="primary"
            size="mini"
            @click.stop="openDragUpload"
            >点击上传</el-button
          >
        </div>
        <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
      </div>
    </div>
    <!-- 素材库 -->
    <MaterialLibrary
      :show.sync="materialLibraryShow"
      :saveAdFileParam="{}"
      :adMaterialParams="{}"
      :currentAccount="currentAccount"
      uploadTypes="IMAGE"
      type="logo"
      :limit="limit"
      @getSelectList="getSelectList"
    />
    <!-- 裁剪图片 -->
    <ImgCut
      :dialog-visible.sync="dialogVisible"
      :image-src="imgUrl"
      :cut-img-params="cutImgParams"
      :file-msg="fileMsg"
      @uploadImg="uploadCutImg"
    />
    <!-- 拖拽上传弹窗 -->
    <DragUploadDialog
      :visible.sync="dragUploadVisible"
      type="logo"
      :limit="limit"
      @files-selected="handleDragFiles"
      @crop-image="handleCropImage"
      ref="dragUploadDialog"
    />
  </div>
</template>
<script>
import ImgCut from '@/views/snapchat/components/imgCut/index';
import getImageSize from '@adCommonComponent/utils/getImageSize.js';
import MaterialLibrary from '@/views/google/create/components/creatives/MaterialLibrary/index.vue';
import DragUploadDialog from '@/views/google/create/components/creatives/DragUploadDialog/index.vue';
import RetryImage from '@/views/google/create/components/creatives/RetryImage/index.vue';
import { uploadImgByUrl } from '@/api/google/create.js';
import useUpLoadFileMixin from '@adCommonComponent/utils/useUpLoadFile.js';
import { formatterName } from '../index';
import { messages } from '@/api/automaticRules';
export default {
  components: { ImgCut, MaterialLibrary, DragUploadDialog, RetryImage },
  mixins: [useUpLoadFileMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      addImgIcon: require('@/assets/icon/addImg.png'),
      dialogVisible: false, //图片裁剪弹窗
      imgUrl: '', //当前裁剪图片的url地址
      cutImgParams: {}, //裁剪图片参数
      fileMsg: {}, //裁剪图片的信息
      initCutParams: {
        outputType: 'png', //输出图片的格式
        infoTrue: true,
      },
      materialLibraryShow: false,
      dragUploadVisible: false,
    };
  },

  computed: {
    limit() {
      return this.type == 'DEMAND_GEN_VIDEO_RESPONSIVE_AD' ? 1 : 5;
    },
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },
  },
  methods: {
    /**
     * 导出数据
     */
    emitMsg() {
      let list = this.value.slice(0, this.limit);
      this.$emit('input', list);
    },
    /**
     * 删除徽标
     */
    deleItem(index) {
      this.value.splice(index, 1);
      this.emitMsg();
    },
    /**
     * 校验尺寸
     */
    validateImgSize(width, height) {
      let isMin = true, //是否大于最小尺寸,支持裁剪
        isPx = false; // 是否符合尺寸，直接上传
      let message = ''; //提示信息
      isPx = height >= 128 && width >= 128 && width / height == 1;
      if (!isPx) {
        if (width < 128 || height < 128) {
          isMin = false;
          message = '图片最小尺寸为 128*128';
        }
      }
      return { isPx, isMin, message };
    },
    /**
     * 校验图片（纯校验，不触发裁剪）
     * @param {Object} file - 图片对象，需包含 type, size/fileSize, width, height, url
     * @returns {Promise<Object>} { valid: boolean, message: string }
     */
    async validateImg(file) {
      const imgTypes = ['image/png', 'image/jpeg', 'IMAGE', 1, '1'];
      const isType = imgTypes.includes(file.type);
      if (!isType) {
        return { valid: false, message: '文件格式不正确' };
      }

      const fileSize = (file.size || file.fileSize || 0) / 1024 / 1024;
      if (fileSize > 5) {
        return { valid: false, message: '图片大小不得超过5M' };
      }

      let { width, height } = file;

      // 如果无法获取宽高，通过 getImageSize 获取
      if (!width || !height) {
        if (!file.url) {
          return { valid: false, message: '无法获取图片尺寸' };
        }
        try {
          const sizeInfo = await getImageSize(file.url);
          width = sizeInfo.width;
          height = sizeInfo.height;
        } catch (error) {
          return { valid: false, message: '获取图片尺寸失败' };
        }
      }

      const sizeResult = this.validateImgSize(width, height);
      if (!sizeResult.isPx) {
        return { valid: false, message: sizeResult.message || '图片尺寸不符合要求（需要1:1比例且>=128*128）' };
      }

      return { valid: true, message: '' };
    },
    /**
     * 设置裁剪参数
     */
    setCutParams(data) {
      this.cutImgParams = { ...this.initCutParams, ...data };
    },

    /**
     * 打开素材库
     */
    openLibrary() {
      this.$emit('openLibrary');
      this.materialLibraryShow = true;
    },
    /**
     * 选择素材库图片（不裁剪，不符合标准直接跳过）
     */
    async getSelectList(list) {
      console.log(list);
      // 遍历所有选中的图片
      for (const img of list) {
        // 达到上限时停止
        if (this.value.length >= this.limit) return;

        // 如果已有 resourceName 且比例为 1:1，直接添加
        if (img.resourceName && img.width / img.height === 1) {
          this.value.push(img);
          this.emitMsg();
          continue;
        }

        // 调用校验逻辑，不符合标准直接跳过
        const validateResult = await this.validateImg({
          type: img.type || 'IMAGE',
          size: img.fileSize,
          width: img.width,
          height: img.height || img.high,
          url: img.url,
        });
        if (!validateResult.valid) {
          this.$message({
            message: `跳过不符合标准的图片: ${img.name || img.file_name}，原因: ${validateResult.message}`,
          });
          console.log(`跳过不符合标准的图片: ${img.name || img.file_name}，原因: ${validateResult.message}`);
          continue;
        }

        try {
          let uploadUrl = img.url;

          // 如果是JPG格式，转换为PNG
          if (img.url && (img.url.toLowerCase().includes('.jpg') || img.url.toLowerCase().includes('.jpeg'))) {
            const response = await fetch(img.url);
            const blob = await response.blob();
            const file = new File([blob], img.name || 'image.jpg', { type: 'image/jpeg' });
            const pngFile = await this.convertJpgToPng(file);

            const res = await this.useUpLoadFile(pngFile);
            uploadUrl = res.url;
          }

          let resData = await this.uploadImgToGoogle(
            {
              name: formatterName(img.name || img.file_name || 'image', img.md5 || '', this.userInfo),
              url: uploadUrl,
            },
            this.currentAccount.id,
          );
          if (!resData) continue;
          this.value.push(resData);
          this.emitMsg();
        } catch (error) {
          console.error('处理素材库图片失败:', error);
        }
      }
    },
    /**
     * 选择图片
     */
    async selectImg(file) {
      console.log(file);
      const imgTypes = ['image/png', 'image/jpeg', 'IMAGE', 1, '1']; //素材库选择的type = 'IMAGE' || '1'
      this.fileMsg = {
        name: file.name,
      };
      let isPx = false;
      let isMin = false;
      let isType = imgTypes.includes(file.type);
      console.log(file.size, ' file.size');
      const fileSize = file.size ? file.size / 1024 / 1024 : 0;
      let isSize = fileSize <= 5;
      // 格式限制
      if (isType) {
        if (!file.url) {
          file.url = URL.createObjectURL(file);
        }
        if (!isSize) {
          this.$message.error('图片大小不得超过5M');
        }
        await getImageSize(file.url)
          .then((res) => {
            const { width, height } = res;
            console.log(width, height);
            let obj = this.validateImgSize(width, height);
            console.log(obj);
            isPx = obj.isPx;
            isMin = obj.isMin;
            if (!isPx) {
              if (!isMin) {
                this.$message.error(obj.message);
              } else {
                this.setCutParams({
                  autoCropWidth: 1200,
                  autoCropHeight: 1200,
                  fixedBox: false,
                  limitMinSize: [128, 128],
                  fixedNumber: [1, 1],
                  infoTrue: true,
                  full: true,
                  centerBox: true,
                  original: true,
                });
                this.dialogVisible = true;
                this.imgUrl = file.url;
              }
            }
          })
          .catch((error) => {
            this.$message.error('文件读取失败');
          });
      } else {
        this.$message.error('文件格式不正确');
      }
      return isPx && isType && isSize && isMin ? Promise.resolve() : Promise.reject();
    },
    /**
     * 上传图片
     */
    async uploadImgHandle(file) {
      console.log(file);
      if (this.value.length >= 5) {
        return;
      }
      this.$showLoading();

      let fileToUpload = file.file;

      // 如果是JPG格式，转换为PNG
      if (file.file.type === 'image/jpeg') {
        fileToUpload = await this.convertJpgToPng(file.file);
      }

      console.log(this.useUpLoadFile, 'this.useUpLoadFile');
      const res = await this.useUpLoadFile(fileToUpload, {
        elOptions: file,
      });
      console.log(res);
      let resData = await this.uploadImgToGoogle(
        {
          name: formatterName(res.fileName, res.md5, this.userInfo), //格式化素材名称
          url: res.url,
        },
        this.currentAccount.id,
      );

      this.$hideLoading();
      if (!resData) return;
      this.value.push(resData);
      this.emitMsg();
      //   uploadImg({ raw: file.file }, this.currentAccount.id)
      //     .then((res) => {
      //       this.$hideLoading();
      //       if (res.code == 0) {
      //         if (this.value.length >= 5) {
      //           return;
      //         } else {
      //           this.value.push(res.data);
      //           this.$emit('input', this.value);
      //         }
      //       }
      //     })
      // .catch((err) => {});
    },
    /**
     * 接收裁剪过的图片上传
     */
    uploadCutImg(file) {
      console.log(file);
      this.uploadImgHandle({ file: file });
    },

    /**
     * 将JPG格式转换为PNG格式
     */
    convertJpgToPng(file) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          canvas.toBlob((blob) => {
            const pngFile = new File([blob], file.name.replace(/\.(jpg|jpeg)$/i, '.png'), {
              type: 'image/png',
              lastModified: Date.now(),
            });
            resolve(pngFile);
          }, 'image/png');
        };

        img.src = URL.createObjectURL(file);
      });
    },

    /**
     * 上传图片到谷歌
     */
    async uploadImgToGoogle(data, accountId) {
      const res = await uploadImgByUrl(data, accountId);
      if (res.code == 0) {
        return res.data;
      } else {
        return null;
      }
    },
    /**
     * 打开拖拽上传弹窗
     */
    openDragUpload() {
      this.dragUploadVisible = true;
    },
    /**
     * 处理拖拽文件
     */
    async handleDragFiles(files) {
      if (this.limit - this.value.length <= 0) return;

      const validFiles = [];
      const existingNames = this.value.map((item) => item.name || item.file_name);

      for (const file of files) {
        // 检查是否重复上传
        if (existingNames.includes(file.name)) {
          this.$message.warning(`${file.name} 已存在，跳过上传`);
          continue;
        }

        try {
          await this.selectImg(file);
          validFiles.push(file);
        } catch (error) {
          // selectImg 已处理错误提示和裁剪逻辑
        }
      }

      // 处理通过验证的文件
      for (const file of validFiles) {
        if (this.value.length >= this.limit) break;
        const fakeFile = {
          uid: Date.now() + Math.random(),
          file: file,
          name: file.name,
        };
        await this.uploadImgHandle(fakeFile);
      }
    },
    /**
     * 处理裁剪图片
     */
    handleCropImage(file) {
      //   this.dragUploadVisible = false;
      this.fileMsg = { name: file.name };
      this.setCutParams({
        autoCropWidth: 1200,
        autoCropHeight: 1200,
        fixedBox: false,
        limitMinSize: [128, 128],
        fixedNumber: [1, 1],
        infoTrue: true,
        full: true,
        centerBox: true,
        original: true,
      });
      this.imgUrl = URL.createObjectURL(file);
      this.dialogVisible = true;
    },
    /**
     * 从文件获取图片尺寸
     */
    getImageSizeFromFile(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        getImageSize(url)
          .then(resolve)
          .catch(reject)
          .finally(() => URL.revokeObjectURL(url));
      });
    },
  },
};
</script>
<style lang="scss">
.uploadGoogleLogo {
  .el-upload--picture-card {
    width: 128px;
    height: 128px;
  }
}
</style>
